export const PreviewAbstractState = {
	url: '/preview',
	abstract: true,
	redirectTo: 'preview.consultation', // default child
	template: '<preview-abstract-page class="abstract"></preview-abstract-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "previewAbstractPageMod" */
			'@Containers/preview-abstract-page/preview-abstract-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
	onEnter: $transition$ => {
		const AuthSvc = $transition$.injector().get('AuthSvc');
		const ThemingService = $transition$.injector().get('ThemingService');
		const user = AuthSvc.currentUser();
		ThemingService.generateSkin({
			brandPrimary: user.theme.primary_color,
			brandSecondary: user.theme.secondary_color,
		});
	},
	onExit: $transition$ => {
		const ThemingService = $transition$.injector().get('ThemingService');
		ThemingService.resetSkin();
	},
	resolve: [
		{
			token: 'logLastAccess',
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.postLastUserAccess({fromState: 'preview', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
	],
};
